import classNames from 'classnames'
import { CompactLabel } from 'app/components/CompactLabel'
import { FilterBadge } from 'app/components/shared/styled/FilterBadge'
import { default as ComboMultiSelectAsync } from 'app/components/ui/combo/combo-multi-select-async'
import { OptionType } from 'types/OptionType'
import type { UseBaseFilterReturn } from './useBaseFilter'
import { Button } from '../ui/button'

export type BaseFilterComponentProps = UseBaseFilterReturn & {
  icon: React.ReactElement
  /** What the chip says when its toolbar narrows, such as "Loc." for Locations. */
  shortName?: string
  optionsMapper: (res: any) => OptionType[]
}

export function BaseFilterComponent({
  attribute,
  displayName,
  icon,
  shortName,
  queryURL,
  fetcher,
  selectedItems,
  totalCount,
  handleChange,
  optionsMapper,
}: BaseFilterComponentProps) {
  return (
    <ComboMultiSelectAsync
      customButton={
        <Button
          variant="white"
          size="sm"
          test-id={`${attribute}-filter-button`}
          className={classNames(
            selectedItems.length > 0 || (totalCount !== null && totalCount > 0)
              ? `text-blue-600 hover:text-blue-600`
              : `text-default`,
          )}
        >
          {icon}
          <CompactLabel className="text-ui-xs" full={displayName} short={shortName} iconOnly />
          <FilterBadge count={selectedItems.length > 0 ? selectedItems.length : totalCount || 0} />
        </Button>
      }
      queryURL={queryURL}
      fetcher={fetcher}
      customLabel=""
      inputClassName="flex !h-8 w-full cursor-pointer items-center justify-between rounded border border-default bg-surface !px-2 !text-body-sm focus:border-subtle focus:outline-none focus:ring-1 focus:ring-strong"
      name={`${attribute}-filter`}
      optionsContainerClassName="max-h-[300px] w-max min-w-[153px] max-w-[620px]"
      values={selectedItems}
      onChangeHandler={handleChange}
      optionsMapper={optionsMapper}
      enableDeselectAllOption
    />
  )
}
